export const STORAGE_KEYS = {
  SESSION: 'lawyerIt_admin',
  PERMISSION_SESSION: '_session_permissionsdist',
  CURRENT_USER_DATA: 'currentUserData',
  TOTAL_COUNT : 'item-count'
};

export const RESPONSE_KEYS = {
  DATAKEY: 'data',
  TOKENKEY: 'token',
  JELLYFISH_ID: 'id',
  TOTAL_COUNT : 'x-total-count',
  STATUS: 'status',
  MESSAGE: 'message',
  ERRORKEY: 'errors',
  USERFROMDIFFERENTPORTAL: 40123
};
